Prism.languages.brainfuck={pointer:{pattern:/<|>/,alias:"keyword"},increment:{pattern:/\+/,alias:"inserted"},decrement:{pattern:/-/,alias:"deleted"},branching:{pattern:/\[|\]/,alias:"important"},operator:/[.,]/,comment:/\S+/};


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components/prism-brainfuck.min.js
// module id = WPrX
// module chunks = 0